<template>
  <TransactionAmountField
    :key="settings?.rule"
    v-model="modelValue"
    v-bind="{
      ...$attrs,
      error,
      description,
      settings,
    }"
  />
</template>

<script setup lang="ts">
import { computed, onBeforeMount } from 'vue'

import { TransactionClass, TransactionComputedEntry } from '@types'

import { preSetAmount } from './utils/helpers'

import TransactionAmountField from './TransactionAmountField.vue'

type Props = {
  entryIndex: number
  instance: TransactionClass
}

const props = defineProps<Props>()

const entryKey = computed(() => `entry${props.entryIndex + 1}` as keyof TransactionClass)

const modelValue = computed({
  get() {
    return (props.instance[entryKey.value] as TransactionComputedEntry)().value?.amount ?? null
  },
  set(value) {
    (props.instance[entryKey.value] as TransactionComputedEntry)().value = {
      ...(props.instance[entryKey.value] as TransactionComputedEntry)().value,
      amount: value ?? null
    }
  },
})

const entrySettings = computed(
  () => props.instance.settings?.entries[props.entryIndex],
)
const settings = computed(() => entrySettings.value?.amount)

const error = computed(
  () => props.instance.errors[`"${entrySettings.value?.title}" amount`],
)

const description = computed(() => entrySettings.value?.amountDescription)

onBeforeMount(() => {
  if (modelValue.value) return
  modelValue.value = preSetAmount(modelValue.value, settings.value)
})
</script>
